import { BreakpointMinSizes } from "@omni/types/enums/breakPoint.enum";
import { LayoutSettings } from "@omni/types/packages/swiper.types";

export const CategorySliderConfig = {
    layoutSettings: {
        [BreakpointMinSizes.xl]: {
            slidesPerView: 6
        },
        [BreakpointMinSizes.lg]: {
            slidesPerView: 5
        },
        [BreakpointMinSizes.md]: {
            slidesPerView: 4
        },
        [BreakpointMinSizes.sm]: {
            slidesPerView: 3.5
        },
        [BreakpointMinSizes.xs]: {
            slidesPerView: 2.5
        }
    } satisfies LayoutSettings,
    spaceBetween: 20
};
